import { setGroup } from "@amplitude/analytics-browser";

export const setAmplitudeAccount = (accountId: string) => {
  setGroup("account_id", accountId);
};
